export const isAdminSession = (session) => ["admin", "super_admin"].includes(session?.role);

export const hasAdminPermission = (session, permission) => {
  if (!isAdminSession(session)) return false;
  const permissions = session?.permissions || [];
  return permissions.includes("full_access") || permissions.includes(permission);
};
